import { useContext } from "react";
import { AppContext } from "../providers/AppProvider";

export const useApp = () => {
  const ctx = useContext(AppContext);

  return ctx;
};
